import React, { useEffect, useState } from 'react';
import Sidebar from '../common/Sidebar';
import { Link, useNavigate } from 'react-router-dom';
import { AdminGetAllProduct, DeleteProductAdmin } from "../../Api/Admin/productServices"
import toast, { Toaster } from 'react-hot-toast';


const ProductList = () => {
  const navigate = useNavigate();
  const [productList, setProductList] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const GetAllProduct = async () => {
      const token = localStorage.getItem("token");
      try {
        const res = await AdminGetAllProduct(token);
        console.log(res.data)
        setProductList(res.data)
      } catch (error) {
        console.log(error)
      }
    }
    GetAllProduct();
  }, [])

  const handleDelete = async (id) => {
    const token = localStorage.getItem("token");
    setLoading(true);
    try {
      const res = await DeleteProductAdmin(token, id);
      console.log(res);
      if (res.status === 200) {
        setProductList((prevList) => prevList.filter((product) => product._id !== id));
        toast.success("product deleted succesfully")
      }
    } catch (error) {
      console.log("Failed to delete product:", error);
      toast.error(error?.message || "something went wrong")
    } finally {
      setLoading(false);
    }
  };
  const handleProductClick = (id) => {
    console.log(id);
    navigate(`/admin/products/${id}`);
  };

  return (
    <div className="flex min-h-screen">
      <Sidebar />
      <Toaster position="top-right" />
      <div className="flex-1 p-4 bg-gray-50" style={{ marginLeft: '16rem' }}>
        <div className="bg-white p-4 rounded-lg shadow-md">
          <div className="flex justify-between items-center mb-4">
            <h1 className="text-xl font-bold">Products</h1>
            <Link to={"/admin/add-products"} className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700">
              Add Product
            </Link>
          </div>

          {/* <div className="flex gap-4 mb-4">
            <select className="border border-gray-300 rounded-lg px-4 py-2 bg-white">
              <option>Category</option>
              <option>Men</option>
              <option>Women</option>
            </select>
            <select className="border border-gray-300 rounded-lg px-4 py-2 bg-white">
              <option>Status</option>
              <option>In Stock</option>
              <option>Out of Stock</option>
            </select>
            <select className="border border-gray-300 rounded-lg px-4 py-2 bg-white">
              <option>Price</option>
              <option>Low to High</option>
              <option>High to Low</option>
            </select>
            <select className="border border-gray-300 rounded-lg px-4 py-2 bg-white">
              <option>Date</option>
              <option>Newest</option>
              <option>Oldest</option>
            </select>
          </div> */}

          <div className="overflow-x-auto">
            <table className="table-auto w-full text-left border-collapse border border-gray-200">
              <thead>
                <tr className="bg-blue-600 text-white">
                  <th className="px-4 py-2">Product Name</th>
                  <th className="px-4 py-2">Brand</th>
                  <th className="px-4 py-2">Category</th>
                  <th className="px-4 py-2">Price</th>
                  <th className="px-4 py-2">Stock</th>
                  <th className="px-4 py-2">Actions</th>
                </tr>
              </thead>
              <tbody>
                {productList?.map((product, index) => (
                  <tr key={index} className="hover:bg-gray-100 border-b ">
                    <td className="px-2 py-2 flex items-center gap-2 cursor-pointer" onClick={() => handleProductClick(product._id)}>
                      <img src={product?.images[0]} alt={product?.title} className="w-16 h-16 rounded-md object-cover" />
                      <span className="text-sm text-gray-500">{product?.title}</span>
                    </td>

                    <td className="px-4 py-2">{product?.brand}</td>
                    <td className="px-4 py-2">{product?.category}</td>
                    <td className="px-4 py-2">${product?.originalPrice}</td>
                    <td className="px-4 py-2">{product?.stock}</td>

                    <td className="px-4 py-2">
                      {loading ? (
                        <button
                          className="text-blue-600 opacity-50 cursor-not-allowed"
                          disabled
                        >
                          Delete
                        </button>
                      ) : (
                        <button
                          className="text-blue-600 hover:underline"
                          onClick={() => handleDelete(product._id)}
                        >
                          Delete
                        </button>
                      )}
                    </td>

                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductList;
